import { Component, OnInit } from '@angular/core';
import { debug, error } from 'console';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import * as alertifyjs from 'alertifyjs';


@Component({
  selector: 'app-codes',
  templateUrl: './codes.component.html',
  styleUrls: ['./codes.component.css']
})
export class CodesComponent implements OnInit {

  codesList:any[] = [];
  filteredCodesList:any[] = [];
  isModalOpen:boolean = false;
  newCode:any = {code: '', name: '', description: '', category: ''}
  formEmpty:any;
  globalError:boolean = false;
  loadingCodes:boolean = false; // Nueva propiedad para loading

  // Filtros
  selectedCategoryFilter: string = 'person';
  selectedStatusFilter: string = '';
  searchTerm: string = '';

  // Opciones de categorización
  categoryOptions = [
    { value: 'person', label: 'Persona' },
    { value: 'product', label: 'Producto' },
    { value: 'bank_accounts', label: 'Medios de pago' }
  ];

  // Asignación de métodos de pago
  selectedBankCode: any = null;
  paymentMethods: any[] = [];
  filteredPaymentMethods: any[] = [];
  selectedPaymentMethods: any[] = [];
  searchPaymentMethod: string = '';
  saving: boolean = false;
  loadingPaymentMethods: boolean = false;

  constructor(
        private _user: UserService,
        public _auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.consultAllCodes();
  }

  serviceCode() {
    if (!this.newCode.code || !this.newCode.name || !this.newCode.category) {
      this.globalError = true;
      return;
    }

    let params = {
      code: this.newCode.code.trim(),
      name: this.newCode.name.trim(),
      description: this.newCode.description?.trim() || '',
      category: this.newCode.category
    };

    if (params.code) {
      this._user.allCodes(params).then(response => {
        alertifyjs.success(`Código agregado exitosamente`);
        this.toggleModal();
        this.consultAllCodes();
      }).catch(error => {
        console.error('Error:', error);
        alertifyjs.error(`El código ya existe`);
      });
    }
  }

 async consultAllCodes(){
    this.loadingCodes = true; // Iniciar loading
    try {
      const response = await this._user.getAllCodes();
      if (response && Array.isArray(response.data)) {
        this.codesList = response.data;
        this.filteredCodesList = [...this.codesList];
        // Apply default filter after loading data
        this.filterByCategory();
      } else {
        this.codesList = [];
        this.filteredCodesList = [];
      }
    } catch (error) {
      console.error('Error en los codigos:', error);
    } finally {
      this.loadingCodes = false; // Finalizar loading
    }
  }

  async updateStatus(code:string, changeStatus:boolean){
    try {
      let newStatus = !changeStatus;
      const response = await this._user.updateCodeStatus(code, newStatus)
      if(response){
        alertifyjs.success(`Estatus cambiado exitosamente`);
        const codeToUpdate = this.codesList.find(item => item.code === code);
        if (codeToUpdate) {
            codeToUpdate.status = newStatus;
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async deleteCodeDynamic(code:string){
    try {
      this._user.deleteCode(code).then(response => {
        if(response){
          alertifyjs.success(`Código eliminado exitosamente`);
          this.codesList = this.codesList.filter(item => item.code !== code)
        }
      }).catch(error => {
        console.error('Error:', error);
        alertifyjs.error(`Error al eliminar el codigo`);
      });

    } catch (error) {
      throw error;
    }
  }

  toggleModal() {
    this.isModalOpen = !this.isModalOpen;
    this.resetForm();
  }

  resetForm(){
    this.newCode = {code: '', name: '', description: '', category: ''}
    this.globalError = false;
  }

  getCategoryLabel(categoryValue: string): string {
    const category = this.categoryOptions.find(opt => opt.value === categoryValue);
    return category ? category.label : 'Sin categoría';
  }

  filterByCategory() {
    this.filteredCodesList = this.codesList.filter(item => {
      const categoryMatch = !this.selectedCategoryFilter || item.category === this.selectedCategoryFilter;
      const statusMatch = !this.selectedStatusFilter || item.status.toString() === this.selectedStatusFilter;
      return categoryMatch && statusMatch;
    });
  }

  filterCodes() {
    this.filteredCodesList = this.codesList.filter(item => {
      const categoryMatch = !this.selectedCategoryFilter || item.category === this.selectedCategoryFilter;
      const statusMatch = !this.selectedStatusFilter || item.status.toString() === this.selectedStatusFilter;
      const searchMatch = !this.searchTerm || 
        item.code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        item.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        (item.description && item.description.toLowerCase().includes(this.searchTerm.toLowerCase()));
      return categoryMatch && statusMatch && searchMatch;
    });
  }

  // Métodos para asignación de métodos de pago
  async loadPaymentMethods() {
    this.loadingPaymentMethods = true;
    try {
      console.log('Cargando métodos de pago...');
      const response = await this._user.account_payment();
      console.log('Respuesta métodos de pago:', response);
      this.paymentMethods = response?.res || response || [];
      console.log('Métodos de pago cargados:', this.paymentMethods.length);
    } catch (error) {
      console.error('Error cargando métodos de pago:', error);
      alertifyjs.error('Error al cargar métodos de pago');
      this.paymentMethods = [];
    }
    this.loadingPaymentMethods = false;
  }

  async onBankCodeSelect() {
    console.log('Código seleccionado:', this.selectedBankCode);
    
    if (!this.selectedBankCode) {
      this.selectedPaymentMethods = [];
      this.searchPaymentMethod = '';
      this.filteredPaymentMethods = [];
      return;
    }
    
    // Cargar métodos de pago cuando se selecciona un código
    await this.loadPaymentMethods();
    
    // Precargar las cuentas existentes si el código ya tiene asignaciones
    this.selectedPaymentMethods = [];
    
    if (this.selectedBankCode.params && this.selectedBankCode.params.accounts && Array.isArray(this.selectedBankCode.params.accounts)) {
      console.log('Precargando cuentas existentes:', this.selectedBankCode.params.accounts);
      
      // Filtrar los métodos de pago que ya están asignados al código
      const existingAccountIds = this.selectedBankCode.params.accounts;
      const preloadedMethods = this.paymentMethods.filter(method => 
        existingAccountIds.includes(method._id)
      );
      
      this.selectedPaymentMethods = [...preloadedMethods];
      console.log('Cuentas precargadas:', this.selectedPaymentMethods.length);
    }
    
    // Mostrar todos los métodos de pago disponibles (excluyendo los ya seleccionados)
    this.filteredPaymentMethods = this.paymentMethods.filter(method => 
      !this.selectedPaymentMethods.some(selected => selected._id === method._id)
    );
  }

  filterPaymentMethods() {
    if (!this.searchPaymentMethod.trim()) {
      // Si no hay búsqueda, mostrar todos los métodos disponibles
      this.filteredPaymentMethods = this.paymentMethods.filter(method => 
        !this.selectedPaymentMethods.some(selected => selected._id === method._id)
      );
      return;
    }

    const searchTerm = this.searchPaymentMethod.toLowerCase();
    this.filteredPaymentMethods = this.paymentMethods.filter(method => {
      // Buscar por método de pago
      const paymentMethodMatch = method.payment_method?.name?.toLowerCase().includes(searchTerm);
      
      // Buscar por banco
      const bankMatch = method.bank?.name?.toLowerCase().includes(searchTerm);
      
      // Buscar por número/teléfono/email
      const numberMatch = method.number?.toLowerCase().includes(searchTerm);
      const phoneMatch = method.phone?.toLowerCase().includes(searchTerm);
      const emailMatch = method.email?.toLowerCase().includes(searchTerm);
      
      // No mostrar métodos ya seleccionados
      const notSelected = !this.selectedPaymentMethods.some(selected => selected._id === method._id);

      return (paymentMethodMatch || bankMatch || numberMatch || phoneMatch || emailMatch) && notSelected;
    });
  }

  addPaymentMethod(method: any) {
    // Verificar que no esté ya agregado
    if (!this.selectedPaymentMethods.some(selected => selected._id === method._id)) {
      this.selectedPaymentMethods.push(method);
    }
    
    // Actualizar la lista filtrada para remover el método agregado
    this.filterPaymentMethods();
  }

  removePaymentMethod(method: any) {
    this.selectedPaymentMethods = this.selectedPaymentMethods.filter(selected => selected._id !== method._id);
    
    // Actualizar la lista filtrada para incluir el método removido
    this.filterPaymentMethods();
  }

  async saveAssignments() {
    if (!this.selectedBankCode || this.selectedPaymentMethods.length === 0) {
      alertifyjs.error('Seleccione un código bancario y al menos un método de pago');
      return;
    }

    this.saving = true;
    try {
      const payload = {
        dynamicCodeId: this.selectedBankCode._id,
        paymentMethodIds: this.selectedPaymentMethods.map(method => method._id)
      };

      debugger
      await this._user.assignPaymentMethodsToCode(payload);
      
      // Actualizar la estructura local del código con las nuevas asignaciones
      const codeIndex = this.codesList.findIndex(code => code._id === this.selectedBankCode._id);
      if (codeIndex !== -1) {
        if (!this.codesList[codeIndex].params) {
          this.codesList[codeIndex].params = {};
        }
        this.codesList[codeIndex].params.accounts = this.selectedPaymentMethods.map(method => method._id);
        
        // También actualizar el objeto selectedBankCode para mantener consistencia
        this.selectedBankCode.params = {
          ...this.selectedBankCode.params,
          accounts: this.selectedPaymentMethods.map(method => method._id)
        };
      }
      
      alertifyjs.success('Métodos de pago asignados exitosamente');
      
      // Limpiar formulario
      this.selectedBankCode = null;
      this.selectedPaymentMethods = [];
      this.searchPaymentMethod = '';
      this.filteredPaymentMethods = [];
      
    } catch (error) {
      console.error('Error asignando métodos de pago:', error);
      alertifyjs.error('Error al asignar métodos de pago');
    }
    this.saving = false;
  }

  get bankAccountCodes() {
    const bankCodes = this.codesList.filter(code => code.category === 'bank_accounts' && code.status);
    console.log('Total códigos en lista:', this.codesList.length);
    console.log('Códigos bank_accounts disponibles:', bankCodes.length, bankCodes);
    return bankCodes;
  }
}
